import { useQuery } from '@tanstack/react-query'
import { fetchBMData } from './fetchBMData'
import { SummaryData, NormalizedSummaryData } from './BMDataTypes'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useBMStore } from '../../stores/useBMStore'
import { useMemo } from 'react'

export const useSummaryQuery = () => {
  const { networkId: networkIdEnc } = useUserStore()
  const domains = useBMStore((state) => state.domains)
  const chosenDomains = useBMStore((state) => state.chosenDomains)
  const { fromDate, toDate } = useBMStore((state) => state.dateRange)

  const rawDomains = chosenDomains?.length ? chosenDomains : domains

  const domainsParam = useMemo<string[]>(() => {
    const unique = Array.from(new Set(rawDomains.map((d) => d.address)))
    return unique.sort()
  }, [rawDomains])

  const allReady = !!networkIdEnc && !!fromDate && !!toDate && domainsParam.length > 0
  const domainsParamKey = domainsParam.join(',')

  const { data, isLoading, isError, error } = useQuery<SummaryData>({
    queryKey: ['summary', networkIdEnc, fromDate, toDate, domainsParamKey],
    enabled: allReady,
    queryFn: () =>
      fetchBMData<SummaryData>('summary', networkIdEnc, {
        params: {
          limit: 300,
          offset: 0,
          'from-date': fromDate,
          'to-date': toDate,
          last3months: false,
          group: '',
          domains: domainsParam,
          search: '',
        },
      }),
  })

  const summary: NormalizedSummaryData = {
    rawData: data,
    summaryEntries: data?.summary?.summary || [],
    isLoading,
    isError,
    error,
  }

  return { summary, isLoading, isError, error }
}
